import mainCaller from './mainCaller';

// 직원 목록 조회 (관리자 변경용)
export async function getEmployeeListForSwitch(token, headBranchId, branchId) {
  const query = branchId
    ? `headBranchId=${headBranchId}&branchId=${branchId}`
    : `headBranchId=${headBranchId}`;
  return await mainCaller(
    `admin/api/v1/positionAuth/employees?${query}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

// 계정 전환 (토큰 필수)
export async function switchAccount(token, userId, password, branchId) {
  const body = { userId };
  if (password) body.password = password;
  if (branchId) body.branchId = branchId;
  return await mainCaller('admin/api/v1/positionAuth/switch', 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
}

// 직원 비밀번호 설정
export async function setEmployeePassword(token, employeeId, data) {
  return await mainCaller(`admin/api/v1/employees/${employeeId}/password`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}
